// Computes area, perimeter and per-unit rows for a polygon.
import { useMemo } from "react";
import { polygonAreaSqm, polygonPerimeterM } from "@/lib/geo";
import { BASE_UNITS, unitSqm } from "@/lib/stateUnits";
import { formatNumber } from "@/lib/units";

const RELEVANT = ["sqm", "sqft", "sqyd", "acre", "hectare", "bigha", "katha", "biswa", "guntha", "cent", "ground", "kanal", "marla"];

export default function usePolygonMetrics(points, state) {
  const areaSqm = useMemo(() => polygonAreaSqm(points), [points]);
  const perimM = useMemo(() => polygonPerimeterM(points), [points]);
  const closed = points.length >= 3;

  const rows = useMemo(() => {
    const out = [
      ["Points placed", String(points.length)],
      ["Perimeter (m)", `${formatNumber(perimM)} m`],
      ["Perimeter (ft)", `${formatNumber(perimM / 0.3048)} ft`],
    ];
    for (const k of RELEVANT) {
      const u = BASE_UNITS.find((b) => b.key === k);
      if (!u) continue;
      out.push([u.label, `${formatNumber(areaSqm / unitSqm(k, state))} ${u.short}`]);
    }
    return out;
  }, [points.length, perimM, areaSqm, state]);

  return { areaSqm, perimM, closed, rows };
}
